import React from 'react';

export default function renderSafeHTML(rawHTML, element = 'span') {
  return React.createElement(element, {
    dangerouslySetInnerHTML: {
      __html: rawHTML
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/render-safe-html.js